<div class="n-list-box-flush-icon">
    <img class="n-list-box-flush-icon-icon" [src]="model.icon" [alt]="model.title" />
    <div class="n-list-box-flush-icon-content">
        <h2>{{model!.title}}</h2>
        <p>
            {{model!.description}} 
        </p>
    </div>
</div>